import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('salutationService', salutationService);

    function salutationService() {
        var SALUTATION_ENUMS = {
            MR: 'MR',
            MRS: 'MRS'
        };
        var salutations = [
            {
                name: 'Mr',
                enum: SALUTATION_ENUMS.MR
            },
            {
                name: 'Mrs',
                enum: SALUTATION_ENUMS.MRS
            }
        ];

        return {
            SALUTATION_ENUMS: SALUTATION_ENUMS,
            salutations: salutations,
            getSalutationByEnum: getSalutationByEnum,
            getSalutationByName: getSalutationByName
        };

        /**
         * Return the object of a salutation for an enum you provide
         *
         * @param {string} salutationEnum The string to be found in {@link SALUTATION_ENUMS}
         * @returns {Object|null} The salutation object as in {@link salutations} or null if none was found
         */
        function getSalutationByEnum(salutationEnum) {
            for (var i = 0; i < salutations.length; i++) {
                if (salutationEnum === salutations[i].enum) {
                    return salutations[i];
                }
            }
            return null;
        }

        /**
         * Return the object of a salutation for a name you provide
         *
         * @param {string} salutationName The string to be found in {@link salutations}
         * @returns {Object|null} The salutation object as in {@link salutations} or null if none was found
         */
        function getSalutationByName(salutationName) {
            for (var i = 0; i < salutations.length; i++) {
                if (salutationName === salutations[i].name) {
                    return salutations[i];
                }
            }
            return null;
        }
    }
})();
